import { canEncodeVideo, canEncodeAudio } from 'mediabunny'

// WebCodecs-backed export (mediabunny's CanvasSource/AudioBufferSource) needs both a video and
// an audio encoder available for the codecs we target. Where it isn't, callers should fall back
// to the MediaRecorder + canvas.captureStream() pipeline (engine/export/mediaRecorderFallback.js).
export const supportsWebCodecsExport = async () => {
    if (typeof window === 'undefined' || !('VideoEncoder' in window)) return false
    try {
        const [videoOk, audioOk] = await Promise.all([
            canEncodeVideo('avc'),
            canEncodeAudio('aac')
        ])
        return videoOk && audioOk
    } catch (e) {
        return false
    }
}
